import {
  NavigationActionTypes,
  NavigationState,
  SET_NAVIGATION_STATE,
} from "./types";

export function setNavigationState(
  state: NavigationState
): NavigationActionTypes {
  return { type: SET_NAVIGATION_STATE, state: state };
}
